// constants

const SET_LANGUAGE = "SET_LANGUAGE";

// reducers

const initialState = false;

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LANGUAGE:
			return action.payload;

		default:
			return state;
	}
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve("resolved");
//     }, 2000);
//   });
// };

// export const testCounterDecrement = () => async (dispatch) => {
//   const result = await resolveAfter2Seconds();
//   console.log(result);
//   dispatch({
//     type: TEST_COUNTER_DECREMENT,
//   });
// };

export const setLanguage = (language) => {
	return {
		type: SET_LANGUAGE,
		payload: language,
	};
};
